import { Field } from 'formik';
import { FormikRadioGroup } from '@flexinet/ui-components';

const priceStatusOptions = [
    { value: '', label: 'All Statuses' },
    { value: 'Active', label: 'Active' },
    { value: 'Inactive', label: 'Inactive' },
];

export const FilterFormComponent = () => {
    return (
        <Field
            name="priceStatus"
            label="Price Status"
            data={priceStatusOptions}
            component={FormikRadioGroup}
            my="md"
        />
    );
};
